import { CRMContact } from './crmContact';
import { CRMProgram } from './crmProgram';

//This should exactly match the entity CRMActivity in C#
export type CRMActivityEntity = {
  activityId: number;
  activityTypeId: number;
  activityType?: ActivityType;
  customerNumber: number | null;
  // handeling on the server side
  createdDate?: string;
  createdByCompanyUserId: number | null;
  attendees: string | null;
  interactionDate: string | null;
  location: string;
  content: string;
  title: string;
  isComplete: boolean;
  isPinned: boolean;
  shipToNumber: string | null;
  attachments?: Attachment[];
  // client side field
  sfaOrder?: any;
  sfaOrderId?: number | null;
  totalAttachments?: number;
} & ActivityTypeFields; // Include additional fields from ActivityTypeFields

export type ActivityType = {
  activityTypeId: number;
  activityType: string;
  isInteraction: boolean;
};

export type ActivityTypeFields = {
  assignedTo: number | null;
  dueDate: string | null;
  addToOutlook?: boolean;
  didRespond?: boolean;
  callDirection: string;
  followUpDate: string | null;
  programs?: CRMProgram[];
  contacts?: CRMContact[];
};

export type Attachment = {
  attachmentId?: number;
  activityId?: number;
  name?: string;
  path?: string;
  fileType?: string;
  createDate?: Date;

  //UI field
  isDeleted?: boolean;
};

export const initialActivityTypeFields: ActivityTypeFields = {
  assignedTo: 0,
  dueDate: '',
  addToOutlook: false,
  didRespond: false,
  callDirection: '',
  followUpDate: '',
  programs: [],
  contacts: [],
};

export const initialCrmActivityEntity: CRMActivityEntity = {
  activityId: 0,
  activityTypeId: 1,
  customerNumber: 0,
  // createdDate: new Date().toISOString(),
  createdByCompanyUserId: 0,
  attendees: '',
  interactionDate: '',
  location: '',
  content: '',
  title: '',
  isComplete: false,
  isPinned: false,
  shipToNumber: null,
  attachments: [],
  totalAttachments: 0,
  ...initialActivityTypeFields,
};
